import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAuthLoading,
  getAuthMfaResponse,
  getAuthUser,
  getThirdPartySSO,
} from 'store/auth/selectors';
import { LoginForm } from 'components/LoginForm';
import { fetchThirdPartySSOUrlRequest, loginRequest } from 'store/auth/actions';
import { Helmet } from 'react-helmet-async';
import { UserDetails } from 'store/signup/models';
//import { RememberUser } from 'store/auth/utils/rememberUser';
import routes from 'routes';
import { Provider } from 'store/api/enums';
import { navigateToExternalPage } from 'utils/validation/common';
import { turnMessageOn } from 'store/app/actions';
import { MessageStates } from 'containers/MessageBox';
import { MessageData } from 'store/app/types';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const LoginPage: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector(getAuthLoading);
  const user = useSelector(getAuthUser);
  const mfaResponse = useSelector(getAuthMfaResponse);
  const thirdPartySSO = useSelector(getThirdPartySSO);
  /* const [savedLoginParams, setSavedLoginParams] =
    React.useState<UserDetails | null>(null); */
  const [showPage, setShowPage] = useState(false);

  const { t } = useTranslation();

  const handleLogin = (
    email: string,
    password: string,
    //rememberMe?: boolean,
    gCaptchaResponse?: string,
    mfaCode?: string | null
  ): void => {
    const loginParams = { email, password } as UserDetails;
    dispatch(loginRequest(loginParams, false, gCaptchaResponse, mfaCode));
  };
  const onProviderLogin = (provider: Provider) => {
    const hostURL = `${process.env.PUBLIC_URL}/main`;
    const baseUrl = process.env.API_URL.replace('tax/api', 'tax').replace(
      '8069/api',
      '8069'
    );
    const providerUrl = `${baseUrl}/oauth2/authorization/${provider}?hostURL=${hostURL}`;

    const providerLabel = t(`common.${provider?.toLowerCase()}`, {
      defaultValue: provider,
    });
    const message: MessageData = {
      title: `Contacting ${providerLabel}`,
      description: t('login.please-be-patient-it-might-take-few-seconds'),
      type: MessageStates.INFO,
    };
    dispatch(turnMessageOn(message));

    thirdPartySSO &&
      localStorage.setItem('thirdPartySSO', JSON.stringify(thirdPartySSO));
    navigateToExternalPage(providerUrl);
  };

  useEffect(() => {
    if (!loading && !!user) navigate(routes.main);
    else setShowPage(true);
  }, [user, loading, navigate]);

  return (
    <React.Fragment>
      {showPage && (
        <>
          <Helmet>
            <title>{`${process.env.PROJECT_NAME} | ${t('login.login')}`}</title>
            <meta
              name="description"
              content={t('login.page-meta-description')}
            />
          </Helmet>

          <LoginForm
            onLogin={handleLogin}
            loading={loading}
            //savedLoginParams={savedLoginParams}
            onProviderLogin={onProviderLogin}
            mfaResponse={mfaResponse}
          />
        </>
      )}
    </React.Fragment>
  );
};
